module.exports = __webpack_public_path__ + "img/failed.07623bba.svg";